import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import EventEHRImageAvatar from "../../Atoms/image-avatar/EventEHRImageAvatar";

interface ListItemsDataProps {
  title?: string;
  subTitle?: string;
  valueOfSubTitle?: string;
  imgURL?: string;
  name?: string;
  totalTask?: number;
  room?: string;
}

interface EventEHRItemListCardProps {
  cardTitle: string;
  listItemsData?: ListItemsDataProps[];
  itemsActionButtonName?: string;
  view?: string;
  noDataDataFoundMessage?: string;

  handleItemsABClick?: (data: any) => void;
  handleViewAllClick?: () => void;
}

export default function EventEHRItemListCard({
  cardTitle = "Card Title Here...",
  listItemsData,
  itemsActionButtonName = "Name",
  view,
  noDataDataFoundMessage,
  handleItemsABClick,
  handleViewAllClick,
}: EventEHRItemListCardProps) {
  return (
    <div className="border-1px-solid-D2D2D2 rounded w-full">
      <div className="flex justify-between items-center m-3">
        <div className="text-sm	font-semibold	 text-[#565656]">{cardTitle}</div>
        {listItemsData?.length ? (
          <div
            className="text-xs font-medium text-[#044677] cursor-pointer"
            onClick={() => {
              handleViewAllClick && handleViewAllClick();
            }}
          >
            View all
          </div>
        ) : (
          ""
        )}
      </div>
      <List sx={{ width: "100%", padding: "0 12px" }}>
        {listItemsData?.map((data, index: any) => (
          <div key={index}>
            <ListItem
              sx={{ padding: view === "todoTaskView" ? "9px 0" : "2px 0" }}
            >
              {!(view === "todoTaskView") ? (
                <EventEHRImageAvatar
                  labelText={data?.title}
                  image={data?.imgURL}
                  commonStyle={{
                    width: "36px",
                    height: "35px",
                    marginRight: "12px",
                    marginBottom: "3px",
                    objectFit: "cover",
                    border: "1px solid #BCBCBC",
                    borderRadius: "50%",
                  }}
                  customTextStyle={{
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                />
              ) : (
                <></>
              )}

              <ListItemText
                primary={
                  <div className="text-sm font-medium text-[#1D1D1D] inline">
                    {data?.title}
                  </div>
                }
                secondary={
                  <React.Fragment>
                    <div className="font-size-10px font-medium text-[#979797] inline">
                      {data?.subTitle}
                    </div>
                    {!(view === "todoTaskView") && (
                      <div className="font-size-10px font-normal text-[#979797] inline">
                        : {data?.valueOfSubTitle}
                      </div>
                    )}
                    {!(view === "todoTaskView") && data?.room && (
                      <div className="font-size-12px font-normal text-[#979797]">
                        Room: {data?.room}
                      </div>
                    )}
                  </React.Fragment>
                }
              />
              <div
                className="text-[#005596] text-xs font-medium cursor-pointer mr-3"
                style={{ whiteSpace: "nowrap" }}
                onClick={() => {
                  handleItemsABClick && handleItemsABClick(data);
                }}
              >
                {itemsActionButtonName}
              </div>
            </ListItem>
            {index !== listItemsData.length - 1 && (
              <Divider variant="fullWidth" component="li" />
            )}
          </div>
        ))}
        {listItemsData?.length === 0 && (
          <div className="flex justify-center items-center font-medium h-[233px] pb-[36px] text-[#7f7f7f]">
            {noDataDataFoundMessage}
          </div>
        )}
      </List>
    </div>
  );
}
